

























































import {traineesClient} from "@/api/clients.context";
import {traineeStatisticsClient} from "@/api/clients.context";
import {Component, Vue} from 'vue-property-decorator';
import {TraineeDailyStatistic, TraineeMathAggregatedStatistic, TraineeProfileModel} from "@/api/api.clients";
import traineeMathTimestableStatistic from "@/components/math/statistics/trainee.math.timestable.statistic.vue";
import traineeMathSingleTimestableStatistics
    from "@/components/math/statistics/trainee.math.singleTimestable.statistics.vue";


@Component({
        components:
            {
                traineeMathTimestableStatistic, traineeMathSingleTimestableStatistics
            }
    }
)

export default class traineeStatistic extends Vue {
    private id: string = '';
    private statistic: TraineeMathAggregatedStatistic | null = null;
    private profile: TraineeProfileModel | null = null;
    private selectedTable: number = 0;
    private latest: TraineeDailyStatistic[] = [];

    async mounted() {

        this.id = this.$route.params.id;
        const prf = await traineesClient.getProfile(this.id);
        this.profile = prf;

        this.latest = await traineeStatisticsClient.getLatestTasks(this.id);
    }

    private onTableSelected(table: number) {
        this.selectedTable = table;
        console.log("table received " + table);
    }
}

